<template>
  <div>
    <Header />
    <Body   />
    <Footer />
  </div>
</template>

<script>
// sub components
import Header from './header.vue'
import Footer from '@/components/footer.vue'
import Body from "./body";

export default {
  name: 'home',
  components: {
    Body,
    Header,
    Footer,
  },
}
</script>
